export const loadedGoogleMapsAPI = new Promise((resolve, reject) => {

    window['GoogleMapsInit'] = resolve;

    let GMap = document.createElement('script');

    GMap.setAttribute('src',
        `https://maps.googleapis.com/maps/api/js?key=AIzaSyB8Qg2pET_s9r7k6TYgnzPmYlcgqGv104U&callback=GoogleMapsInit&region=IN`);

    document.body.appendChild(GMap);
});